import { Button, Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { setCandidatureToEmitOpinion } from "../../../rest/candidature";
import { useParams } from "react-router-dom";
import { useState } from "react";

export function CandidatureFlowApproveEligiblePromoters({ callbackHandler }) {
  const { externalId } = useParams();
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const setCandidatureToEmitOpinionHandler = async () => {
    callbackHandler(() => {
      return setCandidatureToEmitOpinion(externalId);
    });
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <FormattedMessage id="candidature.flow.approveEligiblePromoters" />
        </Modal.Header>
        <Modal.Body>
          <FormattedMessage id="candidature.message.confirmEligiblePromoters" />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleClose}>
            <FormattedMessage id="all.no" />
          </Button>
          <Button variant="outline-primary" onClick={setCandidatureToEmitOpinionHandler}>
            <FormattedMessage id="all.yes" />
          </Button>
        </Modal.Footer>
      </Modal>
      <Button variant="outline-primary" onClick={handleShow}>
        <FormattedMessage id="candidature.flow.approveEligiblePromoters" />
      </Button>
    </>
  );
}
